module.exports =
	title:
		ja: "ヨーロッパにおける19世紀日本関連在外資料調査研究・活用"
		en: "Insights into Japan-related Overseas Artifacts and Documents from 19th-century Europe, Research and Use:"

	subTitle:
		ja: "日本文化発信に向けた国際連携のモデル構築"
		en: "Developing the Foundation for International Collaboration in Transmitting Japanese Culture"
	copyrights:
		ja: "2017 人間文化研究機構ネットワーク型基幹研究プロジェクト"
		en: ""
	primaryNav: [
		{ label: {ja: "総括班", en: "Supervision"}, name: "about", params: {projectName: "supervision"} }
		{ label: {ja: "プロジェクト01", en: "Project 01"}, name: "about", params: {projectName: "project01"} }
		{ label: {ja: "プロジェクト02", en: "Project 02"}, name: "about", params: {projectName: "project02"} }
		{ label: {ja: "プロジェクト03", en: "Project 03"}, name: "about", params: {projectName: "project03"} }
		{ label: {ja: "活動一覧", en: "ACTIVITIES"}, name: "posts", params: {projectName: "all", category: "all", page: 1} }
		{ label: {ja: "刊行物", en: "PUBLICATIONS"}, name: "publications", params: {page: 1} }
		{ label: {ja: "報道記事", en: "NEWS"}, name: "news", params: {page: 1} }
	]
	secondaryNav: [
		{ category: "all", label: { ja: "一覧", en: "ALL"} }
		{ category: "research", label: { ja: "研究調査", en: "RESEARCH"} }
		{ category: "academic", label: { ja: "学術成果", en: "ACADEMIC"} }
		{ category: "education", label: { ja: "活用（展示・教育）", en: "APPLICATION"} }
		{ category: "other", label: { ja: "その他", en: "OTHER"} }
	]
	serverURI: "http://e-zaigai.jp/wp"
	APIURI: "/wp-json/wp/v2/"
	categories: [
		{ slug: "project01", id: 2, label: "Project 01" }
		{ slug: "project02", id: 3, label: "Project 02" }
		{ slug: "project03", id: 4, label: "Project 03" }
		{ slug: "supervision", id: 8, label: "総括" }
		{ slug: "academic", id: 6, label: {ja:"学術成果", en:"ACADEMIC"} }
		{ slug: "education", id: 7, label: {ja: "活用（展示・教育）", en:"APPLICATION"} }
		{ slug: "research", id: 5, label: {ja: "研究調査", en: "RESEARCH"} }
		{ slug: "other", id: 1, label: {ja: "その他", en: "OTHER"} }
	]
	archives: [
		{ slug: "posts", contentType: "posts" }
		{ slug: "post", contentType: "posts" }
		{ slug: "publications", contentType: "publication" }
		{ slug: "publication", contentType: "publication" }
		{ slug: "news", contentType: "news" }
	]
	pages: [
		{
			slug: "top"
			sections: [
				{ postType:"pages", id: 279, loading: false, content: null }
			]
			latests: [
				{ postType:"posts", loading: false, content: null }
			]
		}
		{
			slug: "project01"
			title:
				ja: "ハインリッヒ・フォン・シーボルト（以下シーボルト〈子〉）収集の「もの資料」及び文献資料の総合調査をもとに、データベース化、展示等の活用事業へと展開させるウィーンを中心としたシーボルト（子）収集日本関係資料の調査研究"
				en: "Siebold (Child) Collection centered on Vienna Survey research on Japanese related materials"
			subTitle:
				ja: "Project 01 資源基盤型"
				en: "Project 01 Resource-based type"
			sections: [
				{ postType:"pages", id: 257, loading: false, content: null }
				{ postType:"pages", id: 265, loading: false, content: null }
			]
			latests: [
				{ postType:"posts", slug: "academic", label: {ja:"学術成果", en:"ACADEMIC"}, categoryID: 6, loading: false, content: null}
				{ postType:"posts", slug: "education", label: {ja:"教育活動", en:"EDUCATION"}, categoryID: 7, loading: false, content: null}
				{ postType:"posts", slug: "research", label: {ja:"研究調査", en:"RESEARCH"}, categoryID: 5, loading: false, content: null}
			]
		}
		{
			slug: "project02",
			title:
				ja: "博物館学芸員や教育普及担当者と共に、現地の実情やニーズに応じた日本展示を各地で実現させるイギリスにおける日本展示活性化事業"
				en: "Japan Exhibition Revitalization Project in the UK"
			subTitle:
				ja: "Project 02 対話型"
				en: "Project 02 Interactive"
			sections: [
				{ postType:"pages", id: 259, loading: false, content: null }
				{ postType:"pages", id: 267, loading: false, content: null }
			]
			latests: [
				{ postType:"posts", slug: "research", label: {ja:"研究調査", en:"RESEARCH"}, categoryID: 5, loading: false, content: null}
				{ postType:"posts", slug: "academic", label: {ja:"学術成果", en:"ACADEMIC"}, categoryID: 6, loading: false, content: null}
				{ postType:"posts", slug: "education", label: {ja:"活用（展示・教育）", en:"APPLICATION"}, categoryID: 7, loading: false, content: null}
			]
		}
		{
			slug: "project03",
			title:
				ja: "現地大学及び博物館との連携による資料調査と展示協力を通じて、国内外の日本研究者の養成を支援するスイスにおける大学教育連携事業"
				en: "College Education Collaboration Project in Switzerland"
			subTitle:
				ja: "Project 03 人材育成型"
				en: "Project 03 Human Resource Development Type"
			sections: [
				{ postType:"pages", id: 261, loading: false, content: null }
				{ postType:"pages", id: 269, loading: false, content: null }
			]
			latests: [
				{ postType:"posts", slug: "research", label: {ja:"研究調査", en:"RESEARCH"}, categoryID: 5, loading: false, content: null}
				{ postType:"posts", slug: "academic", label: {ja:"学術成果", en:"ACADEMIC"}, categoryID: 6, loading: false, content: null}
				{ postType:"posts", slug: "education", label: {ja:"活用（展示・教育）", en:"APPLICATION"}, categoryID: 7, loading: false, content: null}
			]
		}
		{
			slug: "supervision",
			title:
				ja: "プロジェクト間連携による研究成果活用"
				en: "supervision"
			subTitle:
				ja: "総括班"
				en: "Supervision"
			sections: [
				{ postType:"pages", id: 263, loading: false, content: null }
				{ postType:"pages", id: 277, loading: false, content: null }
			]
			latests: [
				{ postType:"posts", slug: "research", label: {ja:"研究調査", en:"RESEARCH"}, categoryID: 5, loading: false, content: null}
				{ postType:"posts", slug: "academic", label: {ja:"学術成果", en:"ACADEMIC"}, categoryID: 6, loading: false, content: null}
				{ postType:"posts", slug: "education", label: {ja:"活用（展示・教育）", en:"APPLICATION"}, categoryID: 7, loading: false, content: null}
			]
		}
	]
	links: [
		{
			url: "http://www.nihu.jp"
			title:
				ja: "人間文化研究機構"
				en: "Lorem ipsum"
		}
		{
			url: "http://www.rekihaku.ac.jp/index.html"
			title:
				ja: "国立歴史民俗博物館"
				en: "Lorem ipsum"
		}
		{
			url: "http://www.hi.u-tokyo.ac.jp/index-j.html"
			title:
				ja: "東京大学史料編纂所"
				en: "Lorem ipsum"
		}
		{
			url: "http://www.minpaku.ac.jp"
			title:
				ja: "国立民族学博物館"
				en: "Lorem ipsum"
		}
		{
			url: "http://www.nijl.ac.jp"
			title:
				ja: "国文学研究資料館"
				en: "Lorem ipsum"
		}
		{
			url: "http://www.nichibun.ac.jp/ja/"
			title:
				ja: "国際日本文化研究センター"
				en: "Lorem ipsum"
		}
	]



// WEBPACK FOOTER //
// ./src/config/env.coffee